import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import config from '../lib/config';

export default function Join() {
  const [name, setName]             = useState('');
  const [email, setEmail]           = useState('');
  const [leagueCode, setLeagueCode] = useState('');
  const [loading, setLoading]       = useState(false);
  const [submitted, setSubmitted]   = useState(false);
  const [leagueName, setLeagueName] = useState('');
  const [error, setError]           = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await fetch(`${config.apiUrl}join`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: name.trim(), email: email.trim(), leagueCode: leagueCode.trim().toUpperCase() || undefined }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Request failed'); return; }
      setLeagueName(data.leagueName || '');
      setSubmitted(true);
    } catch {
      setError('Network error — please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="login-logo">
          <h1>WC 2026</h1>
          <p>Predictor League</p>
        </div>

        {!submitted ? (
          <>
            <p style={{ color: 'var(--text-muted)', fontSize: '0.88rem', textAlign: 'center', marginBottom: '1.25rem' }}>
              Enter your details and the admin will send you an invite.
            </p>

            {error && <div className="error-msg" style={{ marginBottom: '1rem' }}>{error}</div>}

            <form className="login-form" onSubmit={handleSubmit}>
              <div className="field">
                <label>Name</label>
                <input
                  type="text"
                  value={name}
                  onChange={e => setName(e.target.value)}
                  placeholder="Your display name"
                  maxLength={80}
                  required
                  autoComplete="name"
                />
              </div>
              <div className="field">
                <label>Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                />
              </div>
              <div className="field">
                <label>
                  League code <span style={{ color: 'var(--text-faint)', fontWeight: 400 }}>(optional)</span>
                </label>
                <input
                  type="text"
                  value={leagueCode}
                  onChange={e => setLeagueCode(e.target.value.toUpperCase())}
                  placeholder="e.g. A3F9B2"
                  maxLength={10}
                  style={{ fontFamily: 'var(--font-mono)', letterSpacing: '.1em' }}
                />
              </div>
              <button type="submit" className="btn btn-primary" disabled={loading || !name.trim() || !email.trim()}>
                {loading ? 'Sending…' : 'Request Access'}
              </button>
            </form>
          </>
        ) : (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '2rem', marginBottom: '0.75rem' }}>✓</div>
            <p style={{ color: 'var(--text)', fontWeight: 600, marginBottom: '0.5rem' }}>Request sent!</p>
            <p style={{ color: 'var(--text-muted)', fontSize: '0.88rem', marginBottom: leagueName ? '0.5rem' : '1.25rem' }}>
              The admin will review your request and send an invite to <strong style={{ color: 'var(--text)' }}>{email}</strong>.
            </p>
            {leagueName && (
              <p style={{ color: 'var(--volt)', fontSize: '0.85rem', fontFamily: 'var(--font-mono)', marginBottom: '1.25rem' }}>
                League: {leagueName}
              </p>
            )}
          </div>
        )}

        <p style={{ textAlign: 'center', marginTop: '1rem' }}>
          <Link to="/login" className="btn-link">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
